module.exports = __webpack_public_path__ + "f7d2e4964f0f250313d6d63e064a6a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1024.jpg
// module id = 611
// module chunks = 0